// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__SRSJA","nav":"Layout_nav__Xp+oL"};